export const regionData: Array<{ key: number; title: string; value: number }> = [
  { key: 1, title: 'USA', value: 1 },
  { key: 2, title: 'EU', value: 2 },
  { key: 3, title: 'LATAM', value: 3 },
]
